import { Dropdown, Menu, Modal } from 'antd';
import { NavLink, useNavigate } from 'react-router-dom';
import {
  ActionMenuIcon,
  AmbientAiIcon,
  BinIcon,
  EditAppointmentIcon,
  NotificationsHistoryIcon,
  PatientIcon,
  QRCodeIcon,
  SendIntakeIcon,
  SummaryIcon,
} from '../../icons';
import {
  getAppointmentDetailsByUuidAction,
  notificationHistory,
  sendAppointmentReminders,
} from '../../store/actions/appointment.action';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import NotificationHistory from '../pageComponents/NotificationHistory';
import { useState } from 'react';
import { EditAppointment } from '../pageComponents/EditAppointmentPage';
import { DeleteAppointment } from '../pageComponents/Delete.Appointment';
import moment from 'moment';
import { getFromStorage, storeInLocal } from '../../lib/storage';
import { ShowQRCode } from '../pageComponents/ShowQRCode.Appointment';
import ConvertAppointmentToAuraEncounterModal from '../../modules/appointments/components/ConvertAppointmentToAuraEncounterModal';
import { useAuth } from '@frontegg/react';
import { analytics } from 'src/services';

const AppointmentTooltip = ({
  showAppointmentDetails,
  setShowAppointmentDetails,
  viewAppointment,
  isfilterOn,
  startIndex,
  filteredData,
  filterValue,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useAuth();

  const { currentPractitioner } = useSelector(
    (state) => state?.practitionerState
  );
  const { settingsOrgValue } = useSelector((state) => state?.appointmentState);
  const isAdmin = settingsOrgValue?.roles?.includes('admin');
  const cachedUserEmail = getFromStorage('user_email');
  const [
    showConvertAppointmentToAuraModal,
    setShowConvertAppointmentToAuraModal,
  ] = useState(false);
  const [
    selectedAppointmentForAuraEncounter,
    setSelectedAppointmentForAuraEncounter,
  ] = useState(null);
  const [deleteText, setDeleteText] = useState('');
  const [storeRecord, setStoreRecord] = useState({});
  const [editAppointmentOpen, setEditAppointmentOpen] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [QRCodeURL, setQRCodeURL] = useState('');
  const [isQRCodeOpen, setIsQRCodeOpen] = useState(false);

  const [isnotificationHistoryOpen, setIsnotificationHistoryOpen] =
    useState(false);
  if (!showAppointmentDetails) {
    return null;
  }
  let statusResponseText = 'Not Started';
  let statusResponseColor = 'new-response';
  if (viewAppointment?.intakeStatus === 'Completed') {
    statusResponseText = 'Completed';
    statusResponseText = (
      <div className="icon">
        Completed
        <NavLink to={`/schedule/${viewAppointment?.appt_uuid}`}></NavLink>
      </div>
    );
    statusResponseColor = 'completed-response';
  } else if (viewAppointment.intakeStatus === 'Unavailable') {
    statusResponseText = 'Unavailable';
    statusResponseColor = 'unavailable-response';
  } else if (viewAppointment.intakeStatus === 'InProgress') {
    statusResponseText = <div className="icon">In Progress</div>;
    statusResponseColor = 'inprogress-response';
  } else if (viewAppointment.intakeStatus === 'partial_completed') {
    statusResponseText = 'Partial Summary';
    statusResponseColor = 'partial-response';
  }
  const handleCancel = () => {
    setShowAppointmentDetails(false);
  };
  const hideConvertAppointmentToAuraModal = () => {
    setShowConvertAppointmentToAuraModal(false);
    setSelectedAppointmentForAuraEncounter(null);
  };

  const handleSendReminder = (uuid, record) => {
    analytics.track('Send Intake Reminder', {
      appointment_date: record?.appointmentDateTime,
      appointment_id: record?.appointment_id,
      appointment_status: record?.intakeStatus,
      practitioner_name: record?.practitioner_Name,
      email: user?.email,
    });
    dispatch(sendAppointmentReminders(uuid, cachedUserEmail));
  };

  const handleDeleteOpen = (appt_uuid, viewAppointment) => {
    analytics.track('Clicked Remove Appointment', {
      appointment_date: viewAppointment?.appointmentDateTime,
      appointment_id: viewAppointment?.appointment_id,
      appointment_status: viewAppointment?.intakeStatus,
      practitioner_name: viewAppointment?.practitioner_Name,
      email: user?.email,
    });
    setDeleteText(viewAppointment);
    setIsDeleteOpen(true);
  };
  const handleShowQRCode = (url, record) => {
    analytics.track('Clicked Show QR Code', {
      appointment_date: record?.appointmentDateTime,
      appointment_id: record?.appointment_id,
      appointment_status: record?.intakeStatus,
      practitioner_name: record?.practitioner_Name,
      email: user?.email,
    });
    setQRCodeURL(url);
    setIsQRCodeOpen(true);
  };

  const handlePatientChatOpen = (url, viewAppointment) => {
    if (url) {
      analytics.track('Opened Lumi Chat', {
        appointment_date: viewAppointment?.appointmentDateTime,
        appointment_id: viewAppointment?.appointment_id,
        appointment_status: viewAppointment?.intakeStatus,
        practitioner_name: viewAppointment?.practitioner_Name,
        email: user?.email,
      });
      window.open(url, '_blank'); // Open the virtual care site URL
    }
  };

  const handleRowClick = (record, type) => {
    storeInLocal('uuid', record?.appt_uuid);

    analytics.track('Opened CareConnect Summary', {
      appointment_date: record?.appointmentDateTime,
      appointment_id: record?.appointment_id,
      appointment_status: record?.intakeStatus,
      practitioner_name: record?.practitioner_Name,
      email: user?.email,
    });
    if (type === 'Menu') {
      analytics.track('Clicked View Summary Action Menu', {
        appointment_date: record?.appointmentDateTime,
        appointment_id: record?.appointment_id,
        appointment_status: record?.intakeStatus,
        practitioner_name: record?.practitioner_Name,
        email: user?.email,
      });
    }
    navigate(`/schedule/${record?.appt_uuid}`);
  };

  const handleEditAppointmentModal = (appt_uuid, viewAppointment) => {
    analytics.track('Clicked Edit Appointment', {
      appointment_date: viewAppointment?.appointmentDateTime,
      appointment_id: viewAppointment?.appointment_id,
      appointment_status: viewAppointment?.intakeStatus,
      practitioner_name: viewAppointment?.practitioner_Name,
      email: user?.email,
    });
    dispatch(
      getAppointmentDetailsByUuidAction(appt_uuid, setEditAppointmentOpen)
    );
  };
  const handleNotificationHistoryModal = (appointmentId, viewAppointment) => {
    setStoreRecord(viewAppointment);
    const notificationHistory_payload = {
      appointment_id: appointmentId,
    };
    dispatch(
      notificationHistory(
        notificationHistory_payload,
        setIsnotificationHistoryOpen
      )
    );
  };

  const handleConvertAppointmentToAuraModal = (appointmentId, record) => {
    setShowConvertAppointmentToAuraModal(true);
    setSelectedAppointmentForAuraEncounter({
      appointmentId,
      record,
    });
  };

  const menuOptions = (id, viewAppointment) => {
    const conditionForReminder = viewAppointment?.actions;
    const canEditAppointments =
      (!viewAppointment?.isExpired &&
        viewAppointment?.intakeStatus !== 'Completed') ||
      (isAdmin &&
        (viewAppointment?.intakeStatus === 'Completed' ||
          viewAppointment?.isExpired));

    return (
      <Menu
        onClick={({ key }) => {
          if (key === 'reminder' && conditionForReminder) {
            handleSendReminder(id, viewAppointment);
          }
          if (key === 'delete') {
            //yes
            handleDeleteOpen(id, viewAppointment);
          }
          if (key === 'patientChat') {
            //yes
            handlePatientChatOpen(
              viewAppointment?.llm_chat_url,
              viewAppointment
            );
          }
          if (key === 'showQRCode') {
            handleShowQRCode(viewAppointment?.llm_chat_url, viewAppointment);
          }
          if (key === 'editAppointment') {
            //yes
            handleEditAppointmentModal(
              viewAppointment?.appt_uuid,
              viewAppointment
            );
          }
          if (key === 'notificationHistory') {
            //yes
            handleNotificationHistoryModal(
              viewAppointment?.appointment_id,
              viewAppointment
            );
          }
          if (key === 'intake') {
            handleRowClick(viewAppointment, 'Menu');
          }
          if (key === 'convertToAuraEncounter') {
            handleConvertAppointmentToAuraModal(
              viewAppointment?.appointment_id,
              viewAppointment
            );
          }
        }}
      >
        {conditionForReminder &&
          viewAppointment?.isExpired === false &&
          viewAppointment?.intakeStatus != 'Unavailable' &&
          viewAppointment?.intakeStatus != 'Completed' && (
            <Menu.Item key="reminder">
              <span className="flex items-center dropdown-text space-x-2">
                <SendIntakeIcon /> <span>Send intake reminder</span>
              </span>
            </Menu.Item>
          )}
        <Menu.Item key="intake">
          <span className="dropdown-text flex items-center space-x-2">
            <SummaryIcon /> <span>View summary</span>
          </span>
        </Menu.Item>
        {viewAppointment?.isExpired === false &&
          viewAppointment?.intakeStatus != 'Unavailable' && (
            <Menu.Item key="patientChat">
              <span className="dropdown-text flex items-center space-x-1">
                <PatientIcon /> <span>Open chat as patient</span>
              </span>
            </Menu.Item>
          )}
        {viewAppointment?.isExpired === false &&
          currentPractitioner?.org_settings?.show_qr_code && (
            <Menu.Item key="showQRCode">
              <span className="dropdown-text flex items-center space-x-1">
                <QRCodeIcon /> <span>Show QR Code</span>
              </span>
            </Menu.Item>
          )}

        {viewAppointment?.intakeStatus === 'New' &&
          !!viewAppointment.llm_chat_url &&
          !viewAppointment?.isExpired && (
            <Menu.Item key="convertToAuraEncounter">
              <span className="dropdown-text flex items-center space-x-2">
                <AmbientAiIcon /> <span>Convert to Aura Encounter</span>
              </span>
            </Menu.Item>
          )}
        {canEditAppointments && (
          <Menu.Item key="editAppointment">
            <span className="dropdown-text flex items-center space-x-2">
              <EditAppointmentIcon /> <span>Edit appointment</span>
            </span>
          </Menu.Item>
        )}
        <Menu.Item key="notificationHistory">
          <span className="dropdown-text flex items-center space-x-2">
            <NotificationsHistoryIcon /> <span>Show notification history</span>
          </span>
        </Menu.Item>
        <Menu.Item key="delete">
          <span className="dropdown-text flex items-center space-x-2">
            <BinIcon /> <span>Remove appointment</span>
          </span>
        </Menu.Item>
      </Menu>
    );
  };

  const { date, time } = viewAppointment.appointmentDateTime;
  const localDateString = moment
    .utc(date, 'MMM Do, YYYY hh:mm A')
    .format('MMM Do, YYYY');
  const localTimeString = moment.utc(time, 'hh:mm A').format('h:mm A');

  return (
    <>
      <Modal
        open={showAppointmentDetails}
        onCancel={handleCancel}
        className="rounded-xl max-w-lg w-full p-6"
        footer={null}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        <div className="flex justify-center items-center border-b">
          <h2 className="text-md font-bold text-[#49454F]">
            Appointment Details
          </h2>
        </div>

        {/* Modal Body */}
        <div className="mt-4">
          <div className="mb-2">
            <span className="font-semibold text-[#49454F]">
              Practitioner Name:{' '}
            </span>
            {viewAppointment.practitioner_Name}
          </div>
          <div className="mb-2">
            <span className="font-semibold text-[#49454F]">
              Appointment Date & Time:{' '}
            </span>
            {localDateString} {localTimeString}
          </div>
          <div className="mb-2">
            <span className="font-semibold text-[#49454F]">Patient Name: </span>
            {viewAppointment.patient_Name}
          </div>
          <div className="mb-2">
            <span className="font-semibold text-[#49454F]">Condition: </span>
            {viewAppointment.condition_name}
          </div>
          <div className="mb-2 flex items-center">
            <span className="font-semibold text-[#49454F] mr-2">
              Intake Status:
            </span>
            <span className={statusResponseColor}>{statusResponseText}</span>
          </div>
          <div className="mb-2 flex items-center">
            <span className="font-semibold text-[#49454F] mr-3">Actions:</span>
            <Dropdown
              className="actionMenu"
              overlay={menuOptions(viewAppointment?.appt_uuid, viewAppointment)}
            >
              <a
                className="ant-dropdown-link"
                onClick={(e) => e.preventDefault()}
              >
                <ActionMenuIcon />
              </a>
            </Dropdown>
          </div>
        </div>
      </Modal>
      {isnotificationHistoryOpen && (
        <>
          <NotificationHistory
            isOpen={isnotificationHistoryOpen}
            setIsOpen={setIsnotificationHistoryOpen}
            record={storeRecord}
            filteredData={filteredData}
          />
        </>
      )}
      {QRCodeURL && (
        <div className="">
          <ShowQRCode
            isOpen={isQRCodeOpen}
            onCancel={() => setIsQRCodeOpen(false)}
            setIsOpen={setIsQRCodeOpen}
            qrCodeValue={QRCodeURL}
          />
        </div>
      )}
      {editAppointmentOpen && (
        <>
          <EditAppointment
            isOpen={editAppointmentOpen}
            onCancel={() => setEditAppointmentOpen(false)}
            setIsOpen={setEditAppointmentOpen}
            startIndex={startIndex}
            isfilterOn={isfilterOn}
            filterValue={filterValue}
          />
        </>
      )}
      {deleteText && (
        <div className="">
          <DeleteAppointment
            isOpen={isDeleteOpen}
            onCancel={() => setIsDeleteOpen(false)}
            setIsOpen={setIsDeleteOpen}
            deleteText={deleteText}
            startIndex={startIndex}
            isfilterOn={isfilterOn}
            filterValue={filterValue}
          />
        </div>
      )}
      {showConvertAppointmentToAuraModal && (
        <ConvertAppointmentToAuraEncounterModal
          showConvertAppointmentToAuraModal={showConvertAppointmentToAuraModal}
          selectedAppointmentForAuraEncounter={
            selectedAppointmentForAuraEncounter
          }
          hideConvertAppointmentToAuraModal={hideConvertAppointmentToAuraModal}
          isfilterOn={isfilterOn}
          startIndex={startIndex}
          filterValue={filterValue}
        />
      )}
    </>
  );
};

export default AppointmentTooltip;
